import React from 'react'
import { Link } from 'react-router-dom';

const NewArrivals = () => {
  return (
    <>
      <div class="hero">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-lg-5">
              <div class="intro-excerpt">
                <h1>New Arrivals</h1>
                <p class="mb-4">Welcome to SpringUp Mattress — your trusted destination for premium mattresses and pillows designed to give you the sleep you deserve. We’re here to make buying a mattress or pillow online simple, affordable, and stress-free.</p>
                <p><Link href="" class="btn btn-secondary me-2">Shop Now</Link><a href="tel:9810201747" className="btn btn-outline-primary" target="_blank" rel="noopener noreferrer">
                  <i className="fa-solid fa-phone"></i> &nbsp; Call Us
                </a></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="product-section">
        <div class="container">
          <div class="row">

            {/* <!-- Start Column 1 --> */}
            <div class="col-md-12 col-lg-3 mb-5 mb-lg-0">
              <h2 class="mb-2 section-title">Crafted with excellent material.</h2>
              <p class="mb-4">Our mattresses and pillows are made using high-quality, durable, and skin-friendly materials to ensure long-lasting comfort and support.</p>
              <p><a href="tel:9810201747" className="btn btn-outline-primary" target="_blank" rel="noopener noreferrer">
                <i className="fa-solid fa-phone"></i> &nbsp; Call Us
              </a></p>
            </div>
            {/* <!-- End Column 1 --> */}

            {/* <!-- Start Column 2 --> */}
            <div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
              <Link class="product-item" to="#">
                <img src="/images/mattress3.jpg" class="img-fluid product-thumbnail" />
                <h3 class="product-title">ComfortLux Spring Mattress</h3>
                <strong class="product-price">₹ 10500</strong>

                <span class="icon-cross">
                  <img src="images/cross.svg" class="img-fluid" />
                </span>
              </Link>
            </div>
            {/* <!-- End Column 2 --> */}

            {/* <!-- Start Column 3 --> */}
            <div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
              <Link class="product-item" to="#">
                <img src="/images/mattress1.jfif" class="img-fluid product-thumbnail" />
                <h3 class="product-title">AirFeel Foam Mattress</h3>
                <strong class="product-price">₹ 7800</strong>

                <span class="icon-cross">
                  <img src="images/cross.svg" class="img-fluid" />
                </span>
              </Link>
            </div>
            {/* <!-- End Column 3 --> */}

            {/* <!-- Start Column 4 --> */}
            <div class="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
              <Link class="product-item" to="#">
                <img src="/images/spring4.jpg" class="img-fluid product-thumbnail" />
                <h3 class="product-title">OrthoCoir Mattress</h3>
                <strong class="product-price">₹ 14430</strong>

                <span class="icon-cross">
                  <img src="images/cross.svg" class="img-fluid" />
                </span>
              </Link>
            </div>
            {/* <!-- End Column 4 --> */}

          </div>
        </div>
      </div>
    </>
  )
}

export default NewArrivals;